/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Zrušit`
};

const da_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Annuller`
};

const de_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Abbrechen`
};

const en_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Cancel`
};

const es_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Cancelar`
};

const fr_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Annuler`
};

const hu_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Mégse`
};

const it_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Annulla`
};

const nl_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Annuleren`
};

const pl_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Anuluj`
};

const pt_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Cancelar`
};

const sv_cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Avbryt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cancel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cancel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cancel", locale)
	if (locale === "cs") return cs_cancel(inputs)
	if (locale === "da") return da_cancel(inputs)
	if (locale === "de") return de_cancel(inputs)
	if (locale === "en") return en_cancel(inputs)
	if (locale === "es") return es_cancel(inputs)
	if (locale === "fr") return fr_cancel(inputs)
	if (locale === "hu") return hu_cancel(inputs)
	if (locale === "it") return it_cancel(inputs)
	if (locale === "nl") return nl_cancel(inputs)
	if (locale === "pl") return pl_cancel(inputs)
	if (locale === "pt") return pt_cancel(inputs)
	return sv_cancel(inputs)
};